import React, { useState  } from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import useStyles from "./styles";
import { searchMovie } from "../../features/currentGenreOrCategory";

const Search = () => {
	const classes = useStyles();
	const [query, setQuery] = useState("");
	const dispatch = useDispatch();
	const location = useLocation();

	const handleKeyPress = (event) => {
		if (event.key === "Enter") {
			console.log("Search query", query);
			dispatch(searchMovie(query));
		}
	};

	const handleClick = () => {
		return dispatch(searchMovie(query));
	};

	if (location.pathname !== "/") return null;

	return (
		<div className={classes.searchContainer}>
			<TextField
				onKeyPress={handleKeyPress}
				value={query}
				onChange={(e) => setQuery(e.target.value)}
				variant="standard"
				InputProps={{
					className: classes.input,
					startAdornent: <InputAdornment position="start"></InputAdornment>,
				}}
			/>
			<SearchIcon onClick={handleClick} style={{ cursor: "pointer" }} />
		</div>
	);
};

export default Search;
